module.exports = __webpack_public_path__ + "static/img/图层 540.0555bfbd.png";